export default __webpack_public_path__ + "static/media/expand_more_even.8405cbd5.svg";